import useWalletContext from './useWalletContext';

const useIsMyAddress = (address) => {
  const { address: myAddress } = useWalletContext();
  return !!address && address === myAddress;
};

export default useIsMyAddress;
